import type { IUserInfo } from "@/account/account-models";
import type { IDictionary } from "@/models";
import { createAction } from "@reduxjs/toolkit";
import type { IChatFilter, IGetChatsConfig } from "./chats-helpers";
import type {
  EBroadcastStage,
  IBroadcastMessage,
  IChatInfo,
  IChatTotals,
} from "./chats-models";

export namespace IChatsActions {
  export enum Type {
    FILTERS__SET = "FILTERS__SET",

    GET__FETCH_CHATS__INIT = "GET__FETCH_CHATS__INIT",
    GET__FETCH_CHATS__SUCCESS = "GET__FETCH_CHATS__SUCCESS",

    UPDATE_CHAT_TOTALS = "UPDATE_CHAT_TOTALS",

    ADD__CHAT_TO_CHATS_LIST = "ADD__CHAT_TO_CHATS_LIST",
    REMOVE__CHAT_FROM_CHATS_LIST = "REMOVE__CHAT_FROM_CHATS_LIST",

    SET__CHAT_EDITING = "SET__CHAT_EDITING",
    TOGGLE__CHAT_SELECTION = "TOGGLE__CHAT_SELECTION",
    SET__ALL_CHATS_SELECTION = "SET__ALL_CHATS_SELECTION",
    TOGGLE__ALL_CHATS_SELECTION = "TOGGLE__ALL_CHATS_SELECTION",

    PATCH__UPDATE_CHATS__SUCCESS = "PATCH__UPDATE_CHATS__SUCCESS",

    SET__BROADCAST_STAGE = "SET__BROADCAST_STAGE",

    POST__BROADCAST_MESSAGE__INIT = "POST__BROADCAST_MESSAGE__INIT",
    POST__BROADCAST_MESSAGE__UPDATE_PROGRESS = "POST__BROADCAST_MESSAGE__UPDATE_PROGRESS",
    POST__BROADCAST_MESSAGE__SUCCESS = "POST__BROADCAST_MESSAGE__SUCCESS",
    POST__BROADCAST_MESSAGE__FAILURE = "POST__BROADCAST_MESSAGE__FAILURE",

    DELETE__BROADCAST_MESSAGE__INIT = "DELETE__BROADCAST_MESSAGE__INIT",
    DELETE__BROADCAST_MESSAGE__SUCCESS = "DELETE__BROADCAST_MESSAGE__SUCCESS",

    SET__BROADCAST_MESSAGE_MEDIA = "SET__BROADCAST_MESSAGE_MEDIA",

    POST__BROADCAST__SUCCESS = "POST__BROADCAST__SUCCESS",
  }
  export const setFilters = createAction<{
    filtersSet: IDictionary<IChatFilter>;
  }>(Type.FILTERS__SET);

  export const addChatToChatList = createAction<{ chat: IChatInfo }>(
    Type.ADD__CHAT_TO_CHATS_LIST
  );
  export const removeChatFromChatList = createAction<{ otherUserId: string }>(
    Type.REMOVE__CHAT_FROM_CHATS_LIST
  );

  export const initGetChats = createAction<{
    url?: string;
    config: Pick<IGetChatsConfig, "isInitialRequest" | "isSneakyReload">;
  }>(Type.GET__FETCH_CHATS__INIT);
  export const successGetChats = createAction<{
    config: Pick<IGetChatsConfig, "isInitialRequest">;
    res: {
      data?: IChatInfo[];
      data_users?: IUserInfo[];
      next: string;
    };
  }>(Type.GET__FETCH_CHATS__SUCCESS);

  export const updateChatTotals = createAction<Partial<IChatTotals>>(
    Type.UPDATE_CHAT_TOTALS
  );

  export const setChatEditing = createAction<boolean>(Type.SET__CHAT_EDITING);
  export const toggleChatSelection = createAction<string>(
    Type.TOGGLE__CHAT_SELECTION
  );
  export const setAllChatsSelection = createAction<boolean>(
    Type.SET__ALL_CHATS_SELECTION
  );
  export const toggleAllChatsSelection = createAction(
    Type.TOGGLE__ALL_CHATS_SELECTION
  );

  export const successPatchUpdateChats = createAction<unknown>(
    Type.PATCH__UPDATE_CHATS__SUCCESS
  );

  export const setBroadcastStage = createAction<{ stage: EBroadcastStage }>(
    Type.SET__BROADCAST_STAGE
  );

  export const initPostBroadcastMessage = createAction<{
    clientSideBroadcastMessage: IBroadcastMessage;
  }>(Type.POST__BROADCAST_MESSAGE__INIT);
  export const updatePostBroadcastMessageProgress = createAction<{
    progress: number;
    loaded: number;
    total: number;
    __clientSideSendId: string | boolean;
  }>(Type.POST__BROADCAST_MESSAGE__UPDATE_PROGRESS);
  export const successPostBroadcastMessage = createAction<{
    clientSideBroadcastMessage: IBroadcastMessage;
  }>(Type.POST__BROADCAST_MESSAGE__SUCCESS);
  export const failurePostBroadcastMessage = createAction<{
    isAbort?: boolean;
    errorResponse?: { message?: string };
    __clientSideSendId?: string | boolean;
  }>(Type.POST__BROADCAST_MESSAGE__FAILURE);

  export const initDeleteBroadcastMessage = createAction<{
    broadcastMessageId: string;
  }>(Type.DELETE__BROADCAST_MESSAGE__INIT);
  export const successDeleteBroadcastMessage = createAction<{
    broadcastMessageId: string;
  }>(Type.DELETE__BROADCAST_MESSAGE__SUCCESS);

  export const setBroadcastMessageMedia = createAction<{
    clientSideBroadcastMessage?: IBroadcastMessage | null;
  }>(Type.SET__BROADCAST_MESSAGE_MEDIA);

  export const successPostBroadcast = createAction<unknown>(
    Type.POST__BROADCAST__SUCCESS
  );
}

export type ChatsActions = Omit<typeof IChatsActions, "Type">;
